module.exports = __webpack_public_path__ + "static/media/valor1.c21a9700.png";